import { Box, Skeleton } from '@sso/shared/core';
import { boxed } from '@sso/shared/hocs';

export type InputSkeletonProps = {
    variant?: 'input' | 'textarea';
    className?: string;
};

function InputSkeleton({ variant = 'input', className }: InputSkeletonProps) {
    return (
        <Box maxWidth={512} className={className}>
            <Skeleton height="textSm" width={100} mb={4} />
            <Skeleton height={variant === 'textarea' ? 116 : 40} width="100%" />
        </Box>
    );
}

export default boxed(InputSkeleton);
